import { render } from "./Salle3Fr.vue?vue&type=template&id=07b883de"
import script from "./Salle3Fr.vue?vue&type=script&lang=js"
export * from "./Salle3Fr.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\marco\\Desktop\\archeo-guida-smart\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__